module.exports = __webpack_public_path__ + "static/media/24.1d434c7c.jpg";